<template>
	<div class="dropdown pull-right">
		<div class="cnt-button" data-toggle="dropdown">
			<i class="fa fa-ellipsis-v"></i>
		</div>
		<ul class="dropdown-menu dropdown-menu-right">
			<li @click="visualizar">
				<a><i class="fa fa-eye"></i> Visualizar</a>
			</li>
			<li @click="toggleContrato">
				<a v-if="row.status == 'suspenso'"
					><i class="fa fa-play"></i>Ativar</a
				>
				<a v-else><i class="fa fa-stop"></i>Suspender</a>
			</li>
			<li @click="RenovarContrato">
				<a><i class="fa fa-refresh"></i> Renovar</a>
			</li>

			<li @click="reverter">
				<a><i class="fa fa-arrow-left"></i> Reverter</a>
			</li>

			<li @click="cancelar">
				<a><i class="fa fa-close"></i> Cancelar</a>
			</li>

			<li class="divider"></li>
			<li class="cnt-btn">
				<button @click="excluir" class="btn btn-danger btn-block">
					<i class="fa fa-trash"></i>
					Excluir
				</button>
			</li>
		</ul>
		<modal-proposta ref="ModalProposta" />
	</div>
</template>
<script>
	import WBS from 'js/http';
	import toastr from 'toastr';
	import ModalProposta from '../../proposals/components/modal.vue';
	import dateFns from 'date-fns';

	export default {
		name: 'ActionsContrac',
		inject: ['row', 'customAction', 'fxdelete', 'updateTab'],
		components: { ModalProposta },
		methods: {
			toggleContrato() {
				WBS.send(
					'private-save-sstContractSuspense',
					this.row.cod,
					(resp) => {
						if (resp.status == 'success' && resp.data == true) {
							toastr.success(
								'Contrato suspender/ativar com sucesso!'
							);
							this.updateTab();
						} else {
							toastr.error('Erro ao suspender/ativar contrato!');
							console.log(resp);
						}
					}
				);
			},

			RenovarContrato() {
				let PropARenovar = JSON.parse(
					JSON.stringify(this.row.cod_proposta)
				);
				delete PropARenovar.cod;
				PropARenovar.obs += `\nRenovação do contrato: ${this.row.cod}`;
				PropARenovar.cnpj = PropARenovar.cnpj.cnpj;
				PropARenovar.cod_categoria = PropARenovar.cod_categoria.cod;
				PropARenovar.cod_tipprop = PropARenovar.cod_tipprop.cod;
				PropARenovar.cod_vendedor = PropARenovar.cod_vendedor.cod;
				PropARenovar.data = dateFns.format(new Date(), 'YYYY-MM-DD');
				PropARenovar.new = 0;
				PropARenovar.renovarContrato = 1;
				PropARenovar.renew = 0;

				this.$refs.ModalProposta.open(PropARenovar);
				// console.log(PropARenovar)
			},
			reverter(action) {
				let sData = {
					contrato: this.row.cod,
					proposta: this.row.cod_proposta.cod,
				};
				WBS.send('private-save-sstContractBack', sData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Contrato retornado com sucesso!');
						this.updateTab();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
			cancelar(action) {
				let sData = {
					contrato: this.row.cod,
					proposta: this.row.cod_proposta.cod,
				};
				WBS.send('private-save-sstContractCancel', sData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Contrato cancelado com sucesso!');
						this.updateTab();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
			visualizar() {
				this.customAction({
					action: 'edit',
					data: this.row,
				});
			},
			excluir() {
				this.customAction({
					action: 'delete',
					data: this.row,
				});
			},
		},
	};
</script>
<style scoped>
	.dropdown-menu > li {
		cursor: pointer;
	}
	.dropdown > i {
		padding: 3px 8px;
		cursor: pointer;
	}
	.dropdown > .cnt-button {
		width: 30px;
		text-align: center;
		cursor: pointer;
	}
	.cnt-btn {
		margin: -5px 6px 0px 6px;
	}
</style>



// WEBPACK FOOTER //
// src/components/contracts/components/actions.vue